import React, { Component } from "react"
import { inject, observer } from 'mobx-react'

import utils from '../utils'
const { FE } = utils

@inject('dialogInfo')
@observer
export default class Dialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      msgIcon: [
        "icon",
        "icon icon-3"
      ]
    }
  }
  render() {
    let {isShow, msg, toUseUrl, btnState} = this.props.dialogInfo.info

    let useStyle = ()=>{
      if(btnState===0){
        return {
          width: 0,
          display: "none"
        }
      }
      if(btnState===1){
        return {
          width: "100%"
        }
      }
      if(btnState===2){
        return {
          width: "50%"
        }
      }
    }
    let cancelStyle = ()=>{
      if(btnState===0){
        return {
          width: "100%"
        }
      }
      if(btnState===1){
        return {
          width: 0,
          display: "none"
        }
      }
      if(btnState===2){
        return {
          width: "50%"
        }
      }
    }
    return (
      <div style={{display: isShow ? "block" : "none"}}>
        <div id="overlay" className="overlay" onClick={this.props.dialogInfo.hide}>
        </div>
        <div id="alertdialog" className="alertdialog">

          <div className="alertdialog-main">
            <p className="dialog-msg">{msg}</p>
          </div>
          <div className="alertdialog-btn">
            <a href={FE.Utils.getHref(toUseUrl)} style={ useStyle() }>立即使用</a>
            <a href="javascript:;" 
              className="js-cancel"
              style={ cancelStyle() }
              onClick={this.props.dialogInfo.hide}>取消</a>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Dialog.js